import { Image, TableRowDisplayEvent, Textbox } from "@mcleod/components";
import { AutogenLayoutDriverManagerProfileList } from "./autogen/AutogenLayoutDriverManagerProfileList";
import { Alignment } from "@mcleod/core";

export class DriverManagerProfileList extends AutogenLayoutDriverManagerProfileList {
    override onLoad() {
        this.mainDataSource.search({});
    }

    tableDriverMgrProfileSearchOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const textboxDriverManagers = tableRow.findComponentById("textboxDriverManagers") as Textbox;
        if (textboxDriverManagers != null) {
            textboxDriverManagers.printableLabel.wrap = false;
            textboxDriverManagers.printableLabel.tooltip = tableRow.data?.getString("driver_managers", null)?.replaceAll(",", ", ") ?? null;
            textboxDriverManagers.printableLabel.tooltipDynamicOptions = { position: Alignment.BOTTOM };
        }

        const imageProfileColor = tableRow.findComponentById("imageProfileColor") as Image;
        if (imageProfileColor != null) {
            const profileColor = tableRow.data?.getString("profile_color", null);
            imageProfileColor.color = profileColor;
            imageProfileColor.visible = profileColor != null;
        }
    }
}
